export * from './GymIcon'
